import React from "react"
import { FormattedMessage } from "react-intl"

export default function SampleStatus({ status, extraStyle = {} }) {
  switch (status) {
    case "pending_analysis" || "pending": {
      return (
        <span className={"text-warning"} style={{ fontStyle: "italic", ...extraStyle }}>
          <FormattedMessage id={"samplemanagement.sample.status.pending_analysis"} />
        </span>
      )
    }
    case "in_progress": {
      return (
        <span style={{ fontStyle: "italic", ...extraStyle }}>
          <span className={"fa fa-clock-o"} />
          &nbsp;
          <FormattedMessage id={"samplemanagement.sample.status.in_progress"} />
        </span>
      )
    }
    case "analyzed": {
      return (
        <span className={"text-success"} style={extraStyle}>
          <span className={"fa fa-check text-success"} />
          &nbsp;
          <FormattedMessage id={"samplemanagement.sample.status.analyzed"} />
        </span>
      )
    }
    case "not_analyzed": {
      return (
        <span className={"text-danger"} style={extraStyle}>
          <span className={"fa fa-exclamation-triangle text-danger"} />
          &nbsp;
          <FormattedMessage id={"samplemanagement.sample.status.not_analyzed"} />
        </span>
      )
    }
    case "success": {
      return (
        <span className={"text-success"} style={extraStyle}>
          <span className={"fa fa-check text-success"} />
          &nbsp;
          <FormattedMessage id={"samplemanagement.sample.submission.status.success"} />
        </span>
      )
    }
    case "failed": {
      return (
        <span className={"text-danger"} style={extraStyle}>
          <span className={"fa fa-exclamation-triangle text-danger"} />
          &nbsp;
          <FormattedMessage id={"samplemanagement.sample.submission.status.failed"} />
        </span>
      )
    }
    case "unknown": {
      return (
        <span style={{ color: "grey", ...extraStyle }}>
          <span className={"fa fa-question-circle"} style={{ color: "grey" }} />
          &nbsp;
          <FormattedMessage id={"general.unknown"} />
        </span>
      )
    }
    default: {
      return <span>{status}</span>
    }
  }
}
